import { useI18n, type MessageKey } from '@/i18n';

interface StatusChipProps {
  status: string;
}

const STATUS_KEYS: Record<string, MessageKey> = {
  planned: 'status.planned',
  in_progress: 'status.in_progress',
  inprogress: 'status.in_progress',
  shipped: 'status.shipped',
  available: 'status.available',
  coming_soon: 'status.coming_soon',
  comingsoon: 'status.coming_soon',
  maintenance: 'status.maintenance',
};

export function StatusChip({ status }: StatusChipProps) {
  const { t } = useI18n();
  const normalized = status.toLowerCase().replace(/\s+/g, '_');
  const key = STATUS_KEYS[normalized];
  return <span className={`status-chip status-chip--${normalized}`}>{key ? t(key) : status}</span>;
}
